
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CommonModule } from '@angular/common';
import { DialogAvatarComponent } from './dialog-avatar.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AlertSummaryModule } from '../alert-summary/alert-summury.module';
import { DragAndDropDirective } from '../../directives/drag-and-drop.directive';
import { DragAndDropModule } from '../../directives/drag-and-drop.module';



@NgModule({
  declarations: [
    DialogAvatarComponent,
    // DragAndDropDirective
  ],

  imports: [
    CommonModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    ImageCropperModule,
    AlertSummaryModule,
    DragAndDropModule
  ],

  exports: [
    DialogAvatarComponent,
    // DragAndDropDirective
  ],

  providers: [ ],

})

export class DialogAvatarModule { }
